const AUTH_SUCCESS = 'AUTH_SUCCESS';
const AUTH_FAIL = 'AUTH_FAIL';
const SET_IS_CERTIFIER = 'SET_IS_CERTIFIER';
const SET_IS_READONLY = 'SET_IS_READONLY';
const SET_NO_ROLES = 'SET_NO_ROLES';
const LOGOUT = 'LOGOUT';
const TOKEN_PERIMETER = 'TOKEN_PERIMETER';
const TOKEN_POO = 'TOKEN_POO';
const SET_IS_ADMIN = 'SET_IS_ADMIN';
const SET_USER_SESSION = 'SET_USER_SESSION';
const SET_USER_LAYERS = 'SET_USER_LAYERS';
const SET_USER_NOTIFICATIONS = 'SET_USER_NOTIFICATIONS';
const SET_UPDATE_PROMPT = 'SET_UPDATE_PROMPT';

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  AUTH_SUCCESS,
  AUTH_FAIL,
  SET_IS_CERTIFIER,
  SET_IS_READONLY,
  SET_NO_ROLES,
  LOGOUT,
  TOKEN_PERIMETER,
  TOKEN_POO,
  SET_IS_ADMIN,
  SET_USER_SESSION,
  SET_USER_LAYERS,
  SET_USER_NOTIFICATIONS,
  SET_UPDATE_PROMPT
};
